document.addEventListener("DOMContentLoaded", async () => {
    if (typeof google === "undefined" || typeof google.maps === "undefined") {
        console.error("Google Maps API did not load.");
        return;
    }

    try {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        document.querySelectorAll(".cities-map-block").forEach((block) => {
            const cities = JSON.parse(block.dataset.cities || "[]");
            const mapContainer = block.querySelector(".map-container");
            const iconBlue = block.dataset.iconBlue;
            const iconOrange = block.dataset.iconOrange;

            const mapImageUrl = block.dataset.mapImageUrl || "";
            const layoutStyle = block.dataset.layoutStyle || "style1";

            const cityItems = layoutStyle === "style2"
                ? block.querySelectorAll(".map-nav-item")
                : block.querySelectorAll(".city-item");

            const sideImage = block.querySelector(".side-image-container img");

            if (!mapContainer || !iconBlue || !iconOrange) return;

            const defaultCenter = cities.length
                ? { lat: parseFloat(cities[0].lat), lng: parseFloat(cities[0].lng) }
                : { lat: 39.8283, lng: -98.5795 };

            const map = new Map(mapContainer, {
                center: defaultCenter,
                zoom: cities.length > 1 ? 12 : (cities.length === 1 ? 10 : 4),
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true,
                gestureHandling: "cooperative",
                mapId: "66b205ff503f486ca69237c1"
            });

            const bounds = new google.maps.LatLngBounds();
            const infoWindow = new google.maps.InfoWindow();
            const markers = [];
            let activeIndex = null;

            const updateSidebarImage = (newSrc) => {
                if (!sideImage || layoutStyle !== "style1") return;
                sideImage.style.opacity = 0;
                setTimeout(() => {
                    sideImage.src = newSrc || mapImageUrl;
                    sideImage.style.opacity = 1;
                }, 200);
            };

            cities.forEach((city, index) => {
                const lat = parseFloat(city.lat);
                const lng = parseFloat(city.lng);
                if (isNaN(lat) || isNaN(lng)) return;

                const iconUrl = (city.icon === "orange" && iconOrange) ? iconOrange : iconBlue;

                const markerImg = document.createElement("img");
                markerImg.src = iconUrl;
                markerImg.style.width = "32px";
                markerImg.style.height = "38px";
                markerImg.style.cursor = "pointer";

                const marker = new AdvancedMarkerElement({
                    map,
                    position: { lat, lng },
                    title: city.title,
                    content: markerImg,
                    gmpClickable: true
                });

                markers.push(marker);
                bounds.extend({ lat, lng });

                const buildInfoHtml = () => `
                    <div class="custom-info-window">
                        <h3>${city.title}</h3>
                        ${city.communities && city.communities.length ? `
                            <ul>
                                ${city.communities.map(c => `
                                    <li><a href="${c.url}" target="_blank">${c.name}</a></li>
                                `).join("")}
                            </ul>` : ""}
                    </div>
                `;

                const activateMarker = () => {
                    // Reset previous active
                    if (activeIndex !== null) {
                        const prevIconUrl = (cities[activeIndex].icon === "orange" && iconOrange) ? iconOrange : iconBlue;
                        markers[activeIndex].content.src = prevIconUrl;
                        cityItems[activeIndex]?.classList.remove("active");
                    }

                    // Activate current
                    marker.content.src = iconUrl;
                    cityItems[index]?.classList.add("active");
                    activeIndex = index;

                    updateSidebarImage(city.cityImageUrl);
                };

                marker.addEventListener("gmp-click", () => {
                    activateMarker();
                    infoWindow.setContent(buildInfoHtml());
                    infoWindow.open({ map, anchor: marker });
                });

                // Click on city list / nav
                if (cityItems[index]) {
                    cityItems[index].addEventListener("click", () => {
                        map.setCenter({ lat, lng });
                        map.setZoom(12);
                        activateMarker();
                        infoWindow.setContent(buildInfoHtml());
                        infoWindow.open({ map, anchor: marker });
                    });
                }
            });

            // Close info window handler
            google.maps.event.addListener(infoWindow, "closeclick", () => {
                if (activeIndex !== null) {
                    const defaultIconUrl = (cities[activeIndex].icon === "orange" && iconOrange) ? iconOrange : iconBlue;
                    markers[activeIndex].content.src = defaultIconUrl;
                    cityItems[activeIndex]?.classList.remove("active");
                    activeIndex = null;
                    updateSidebarImage(mapImageUrl);
                }
            });

            if (cities.length > 1) {
                map.fitBounds(bounds, { padding: 60 });
            } else if (cities.length === 1) {
                map.setZoom(10);
            }
        });

    } catch (err) {
        console.error("Google Maps initialization error:", err);
    }
});